import { Tag } from "antd";
import { getRoleDisplayName, getRoleStyle } from "../../utils/roleUtils";

export const useUserUtils = () => {
  // Function to get role tag styling
  const getRoleTagOption = (roleValue) => {
    const { borderColor, textColor, backgroundColor } = getRoleStyle(roleValue);
    const displayName = getRoleDisplayName(roleValue);

    return {
      label: (
        <Tag
          style={{
            border: `1px solid ${borderColor}`,
            borderRadius: "60rem",
            background: backgroundColor,
            color: textColor,
            fontFamily: "Inter",
            fontSize: "0.75rem",
            fontWeight: 400,
            padding: "0 0.5rem",
            margin: "2px",
          }}
        >
          {displayName}
        </Tag>
      ),
      value: roleValue,
    };
  };

  // Common styles for buttons
  const commonButtonStyles = {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    color: "#0e49b5",
  };

  return {
    getRoleTagOption,
    commonButtonStyles
  };
};
